import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import { httpClient } from '@/shared/lib/httpClient'
import { apiV1 } from '@/shared/api/apiPrefix'

const mePointsBalanceResponseSchema = z.object({
  meta: z.object({ points_balance: z.number().optional() }),
})

/**
 * T6.16 - lightweight points balance read for the HS wish screens (shared/ so
 * features/reservation doesn't couple to features/profile's full ledger hook).
 * Reuses the paginated `/me/points` endpoint, ignoring pagination - same source of truth
 * as the profile "Mes points" tab.
 */
export function useMePointsBalance(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['me', 'points', 'balance'],
    queryFn: async (): Promise<number> => {
      const res = await httpClient.get<unknown>(apiV1('/me/points'))
      return mePointsBalanceResponseSchema.parse(res.data).meta.points_balance ?? 0
    },
    // Widget mounted on every authenticated page header - avoid refetching on each mount.
    staleTime: 60_000,
    enabled: options?.enabled ?? true,
  })
}
